import styled from 'styled-components';

const AboutUsReview = styled.div`
  font-style: italic;
`;

export default AboutUsReview;
